<mat-form-field class="w-100" appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    type="number"
    [formControl]="control"
    [min]="min"
    [max]="max"
    (input)="this.onChange($event.target.value)"
    (blur)="this.onBlurEvent()"
  />
  <mat-error *ngIf="error">{{ error }}</mat-error>
</mat-form-field>
